<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add()">新增</Button>
			<Button type="primary" @click="updateMenu()">修改权限</Button>
		</div>
		<div class="query">
			<div class="checkbox">
				<Select v-model="query.roleId" filterable clearable='true' @on-clear="onclear" @on-change="onchange">
					<Option v-for="item in roles" :value="item.id" :key="item.id">{{ item.name }}</Option>
				</Select>
			</div>
			<Input search enter-button placeholder="请输入地址/名称查询" v-model='query.like' style="width: 500px;" @on-search="ajaxPage()" />
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading" @on-selection-change="onselectionchange">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">详情</Button>
				<Button type="error" size="small" style="margin-right: 5px" @click="yichu(row.id)" v-if="query.roleId!='' && row._checked">移除</Button>
			    <Button type="info" size="small" style="margin-right: 5px" @click="tianjia(row.id)" v-if="query.roleId!='' && !row._checked  && row.noNeedLogin">添加</Button>
						
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				roles:[],
				loading: false,
				total: 0,
				query: { //查询参数
					page: 0,
					size: 10,
				    roleId:'',
					like:''
				},
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: 'id',
						key: 'id'
					},
					{
						title: '权限名称',
						key: 'name'
					},
					{
						title: '权限类型',
						key: 'menuTypeString'
					},
					{
						title: '权限字符串',
						key: 'privilege'
					},
					{
						title: '访问链接',
						key: 'url'
					},
					{
						title: '是否需要登陆访问',
						key: 'noNeedLogin',
						render: (h, params) => {
							if (params.row.noNeedLogin == true) {
								return h("div", "需要")
							} else {
								return h("div", "不需要")
							}
						}
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: [
					/* 	{
						id: '1',
						companyName: '',
						address: '',
						phone1: '',
						phone2: '',
						phone3: '',
						mailbox: '',
						operType: '',
						state: '',
						createdTime: '2010-10-10'

					}, */
				]

			}
		},
		methods: {
			updateMenu(){
				
			},
			tianjia(menuId){
				let _this=this
				console.log(_this.query.roleId=='')
				if(_this.query.roleId==''){
					_this.$Message.error('请先选择角色!');
					return ;
				}
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/role/add/menu',
				    data: {
						roleId:_this.query.roleId,
						menuId:menuId
					},
					_this: _this,
					success: function(data) {
						_this.$Message.success('添加成功!');
						_this.ajaxPage()
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			yichu(menuId){
				let _this=this
				if(_this.query.roleId==''){
					_this.$Message.error('请先选择角色!');
					return ;
				}
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/role/remove/menu',
				    data: {
						roleId:_this.query.roleId,
						menuId:menuId
					},
					_this: _this,
					success: function(data) {
						_this.$Message.success('修改成功!');
						_this.ajaxPage()
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			onchange(){
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage()
			},
			onclear(){
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage()
			},
			onselectionchange(a){
				console.log(this.data6)
				console.log(a)
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			update(id) { //修改
				this.$router.push({
					name: 'jm/admin/menu/update',
					query: {
						id: id
					}
				})
			},
			add() {
				this.$router.push({
					name: 'jm/admin/menu/add'
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/menu/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.data6=data.map.menus
						_this.total = data.map.totalElements
						
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			queryRole() {
				this.loading = true
				let _this=this
				let query= { //查询参数
					page: 0,
					size: 100
				}
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/role/page',
				    data: query,
					_this: _this,
					success: function(data) {
						_this.roles = data.roles.content
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}

		},
		components: {
			page
		},
		created() {
			this.ajaxPage();
			this.queryRole()
		}


	}
</script>
<style scoped="scoped">
	.ivu-table-cell {
		padding-left: 0px !important;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/jurisdiction/menu/list.vue